    export const view = {
        namespaced: true,
        state: {
            zipImages: {},
            recentVideos: {},
        },
    mutations: {
        SET_ZIP_STATE(state, payload) {
            const { zipFilename, index, fileName } = payload

            state.zipImages = {
                ...state.zipImages,
                [zipFilename]: { index, fileName }
            }

            const keys = Object.keys(state.zipImages)

            if (keys.length > 20) {
                delete state.zipImages[keys[0]]
            }
        },
        setRecentVideo(state, payload) {
            state.recentVideos[payload.file] = {
                currentTime: payload.currentTime,
                updatedAt: Date.now()
            };

            // 최근 5개 유지
            const entries = Object.entries(state.recentVideos)
                .sort((a, b) => b[1].updatedAt - a[1].updatedAt)
                .slice(0, 5);

            state.recentVideos = Object.fromEntries(entries);
        }
    }
};
